import {BasicItem, Constants} from "./shared.models";
import {HttpParams} from "@angular/common/http";

export class Response {
  public ErrorCode = 0;
  public ErrorMessage: string | null = null;
  public IsSuccess : boolean = true;
  public OutID : number = 0;
  public OutIDEnc : string = '';
}

export class DataResponse<T> extends Response {
  public Item: T | null = null;
  public Items: T[] | null = null;

  public static error<T>(code?: number){
    const r = new DataResponse<T>();
    r.ErrorCode = code ?? Constants.ERROR_DEFAULT;
    return r;
  }
}

export class InterceptorCloneRequest {
  public data : string = "";
  public replace : boolean = false;
}

export class CustomHttpInterceptParams extends HttpParams {
  showLoader: boolean;

  constructor(showLoader: boolean = true) {
    super();
    this.showLoader = showLoader;
  }
}

export class ListDataResponse<T> extends DataResponse<T> {
  public totalCount: number | null = null;

  public static override error<T>(code?: number){
    const r = new ListDataResponse<T>();
    r.ErrorCode = code ?? Constants.ERROR_DEFAULT;
    return r;
  }
}

export class Errors {
  public static readonly NotFound = 404;

  /// <summary>L'utente e' gia' candidato all'annuncio</summary>
  public static readonly UserAlreadyApplied = 1001;

  /// <summary> L'utente ha effettuato il login social ma non è ancora registrato sulla piattaforma </summary>
  public static readonly UserSocialRegistrationToComplete = 10001;

  /// <summary> L'utente non ha confermato la mail di registrazione </summary>
  public static readonly UserEmailNotConfirmed = 10002;

  /// <summary> Dati personali inseriti non validi </summary>
  public static readonly InvalidProfilePersonaData = 20001;

  /// <summary> Dati sull'esperienza di lavoro inseriti non validi </summary>
  public static readonly InvalidProfileJobExperience = 20002;

  /// <summary> Dati sul titolo di studio non validi </summary>
  public static readonly InvalidProfileStudies = 20003;

  /// <summary> Limiti delle valutazioni infranti (max 1 voto 10, 3 voti 9, ...)</summary>
  public static readonly ValuationsLimitsBreak = 30001;
  public static readonly InvalidOperationCode = 30002;

  public static readonly EmailInvaildRequest = -90000;
  public static readonly EmailInvaildDestinationAddress = -90001;
  public static readonly EmailInvaildSourceAddress = -90002;
}

